import React, {Component, Fragment}  from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom';

import NotificationSystem from 'react-notification-system';
import {BeatLoader} from 'react-spinners';
import ReactTable from 'react-table'

const data={
    name: "student one",
    status: 5,
    grade : "Reduced",
    eligibility : 3,

}
class MealBenifitsApplicationEdit extends Component {
    constructor(props) {
        super(props)
        this.state={
            loading:false,
            initStep:0,
           
        }
    }
  
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
    }

    render (){
        return (
            <div>
                <NotificationSystem ref="notificationSystem"/>                
                    <section className=" full-width clearfix margin-top">
                        <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        
                    </section>
            </div>
        )
    }
}

MealBenifitsApplicationEdit.contextTypes = {
    router: PropTypes.object.isRequired
}

export default MealBenifitsApplicationEdit


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolMealBenifitsApplications/mealBenifitsApplicationEdit.jsx